export class FloatingPresenceParam {
    param: string;
    value: string;
    visible: boolean;
}
